import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=33e08ee6"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"
import style0 from "./Sider.vue?vue&type=style&index=0&id=33e08ee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports